import {PersonaInfo} from "../../shared/interfaces/shared-interface";

export interface ProyectoPerfil {
    personaInfo?: PersonaInfo
    tipo_propietario?: string;
    idTenencia?: number|string,
    idPersona?: number,
    uniqueId?: string;
    idProyecto?: number,
    archivo?: string | File | null
    hash?: string
    nombreArchivo?: string
    idTipoArchivo?: string | number
    idTipoPersona?: string
    idPasoGeneralidades?: number | null;
    idRequisito?: number | null | string | any;
    caso?: number | null | any;
    tipoPersona?: string
    pageRefresh?: boolean; //variable que identifica cuando se actualiza la pagina
}
export function defaultProyectoPerfil(): ProyectoPerfil {
    return {
        personaInfo: undefined,
        tipo_propietario: '',
        idTenencia: 0,
        idPersona: 0,
        uniqueId: '',
        idProyecto: 0,
        archivo: null,
        hash: '',
        nombreArchivo: '',
        idTipoArchivo: '',
        idTipoPersona: '',
        idPasoGeneralidades: null,
        idRequisito: null,
        caso:null,
        tipoPersona:'',
        pageRefresh:false
    };
}
